/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description patients constants
 */

import { MONTH_DATE_YEAR_SLASH_FORMAT } from '@veritable/common/constants';

const PATIENT_SEARCH_FIELDS = {
	MRN: {
		key: 'MRN',
		title: 'MRN',
		placeholder: 'E.g.: WXI234FJCHI',
	},

	SSN: {
		key: 'SSN',
		title: 'SSN',
		placeholder: 'E.g.: 000000000',
		info: 'Enter the 9 digit SSN',
	},
	memberId: {
		title: 'Member ID',
		placeholder: 'E.g.: WXI234FJCHI',
	},
	patientName: {
		key: 'patientName',
		title: 'Name',
		placeholder: 'E.g.: John Doe',
	},
	birthDate: {
		key: 'birthDate',
		title: 'DOB',
		placeholder: MONTH_DATE_YEAR_SLASH_FORMAT,
	},
	patientResponsibility: {
		title: 'Patient Responsibility',
		placeholder: { min: 'Min', max: 'Max' },
	},
	advancedSearchButtons: { reset: 'Clear', submit: 'Search' },
};

const PREFERRED_CONTACT_METHODS: { label: string; value: Fhir.ContactPoint['system'] }[] = [
	{ label: 'Phone', value: 'phone' },
	{ label: 'Fax', value: 'fax' },
	{ label: 'Email', value: 'email' },
	{ label: 'Pager', value: 'pager' },
	{ label: 'URL', value: 'url' },
	{ label: 'SMS', value: 'sms' },
	{ label: 'Other', value: 'other' },
];
export { PATIENT_SEARCH_FIELDS, PREFERRED_CONTACT_METHODS };
